<script setup></script>

<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="2.5"
      width="45"
      height="45"
      rx="22.5"
      fill="white"
    />
    <rect
      x="2.5"
      y="2.5"
      width="45"
      height="45"
      rx="22.5"
      stroke="#FC4C71"
      stroke-width="5"
    />
    <path
      d="M24.9974 4.16797C13.4974 4.16797 4.16406 13.5013 4.16406 25.0013C4.16406 36.5013 13.4974 45.8346 24.9974 45.8346C36.4974 45.8346 45.8307 36.5013 45.8307 25.0013C45.8307 13.5013 36.4974 4.16797 24.9974 4.16797ZM19.3516 33.9388L11.8724 26.4596C11.6795 26.2668 11.5265 26.0378 11.4221 25.7858C11.3177 25.5338 11.264 25.2637 11.264 24.9909C11.264 24.7181 11.3177 24.448 11.4221 24.196C11.5265 23.944 11.6795 23.715 11.8724 23.5221C12.0653 23.3293 12.2943 23.1763 12.5463 23.0719C12.7983 22.9675 13.0684 22.9138 13.3411 22.9138C13.6139 22.9138 13.884 22.9675 14.136 23.0719C14.388 23.1763 14.617 23.3293 14.8099 23.5221L20.8307 29.5221L35.1641 15.1888C35.5536 14.7993 36.0819 14.5804 36.6328 14.5804C37.1837 14.5804 37.712 14.7993 38.1016 15.1888C38.4911 15.5783 38.7099 16.1067 38.7099 16.6576C38.7099 17.2084 38.4911 17.7368 38.1016 18.1263L22.2891 33.9388C22.0963 34.1319 21.8674 34.2852 21.6154 34.3897C21.3633 34.4943 21.0932 34.5481 20.8203 34.5481C20.5475 34.5481 20.2773 34.4943 20.0253 34.3897C19.7732 34.2852 19.5443 34.1319 19.3516 33.9388Z"
      fill="#FC4C71"
    />
  </svg>
</template>

<style scoped></style>
